import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { InputLabel, MenuItem, Select, TextareaAutosize } from '@mui/material';

// import Loader from '../../pages/Loader/Loader';

import axios from 'axios';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChapterListtable from '../ChapterListComponent/ChapterListtable';

// import Select from "@mui/material/Select";
// import MenuItem from "@mui/material/MenuItem";
// import InputLabel from "@mui/material/InputLabel";
// import { FormControl } from "@mui/material";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 1,
  outline: 'none',
  p: 4,
  marginTop: 4,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: '#F0411A',
      contrastText: '#fff',
    },
  },
});

const Modalvideolist = ({
  courses,
  chapters,
  course,
  setCourse,
  render,
  setRender,
  chapter,
  setChapter,
}) => {
  const [open, setOpen] = React.useState(false);
  // const [loading, setLoading] = React.useState(false);

  const [videoName, setVideoName] = React.useState('');
  const [videoFile, setVideoFile] = React.useState('');
  // const [user, setUser] = React.useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //////////////////////////////////////////////////

  const createVideoHandler = async () => {
    try {
      const response = await axios.post(
        `api/v1/a34jl49u-q4r67p89/courses/${course._id}/chapter/${chapter._id}/video`,
        {
          name: videoName,
          link: videoFile,
          course: course._id,
          chapter: chapter._id,
          // user,
        }
      );

      if (response.status === 201 || response.statusText === 'Created') {
        toast.success('success');
        setRender(!render);
        handleClose();

        return;
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Button variant='contained' color='neutral' onClick={handleOpen}>
          Create-Video
        </Button>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Two Digit Lucky Number
          </Typography> */}
          <Typography id='modal-modal-description' sx={{ mt: 2 }}>
            <TextField
              sx={{ width: '100%' }}
              id='outlined-search'
              label='Name'
              type='text'
              onChange={(e) => setVideoName(e.target.value)}
            />
            <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='Link'
              type='text'
              // onChange={(e) => setVideoFile(e.target.files[0])}
              onChange={(e) => setVideoFile(e.target.value)}
            />

            <InputLabel>Course</InputLabel>

            <Select
              fullWidth
              size='small'
              value={course}
              placeholder='Course'
              onChange={(e) => setCourse(e.target.value)}
              // onClick={handleclick}
            >
              {courses?.map((course, index) => (
                <MenuItem key={index} value={course}>
                  {/* {course?._id} */}
                  {course?.name}
                </MenuItem>
              ))}
            </Select>

            <InputLabel>Chapter</InputLabel>

            <Select
              fullWidth
              size='small'
              value={chapter}
              placeholder='Chapter'
              onChange={(e) => setChapter(e.target.value)}
              // onClick={handleclick}
            >
              {chapters?.map((chapter, index) => (
                <MenuItem key={index} value={chapter}>
                  {chapter?.name}
                </MenuItem>
              ))}
            </Select>

            {/* <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='Course'
              type='text'
              onChange={(e) => setCourse(e.target.value)}
            />
            <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='Chapter'
              type='text'
              onChange={(e) => setChapter(e.target.value)}
            /> */}

            {/* <TextField
              sx={{ width: '100%', marginTop: 1 }}
              id='outlined-search'
              label='User'
              type='text'
              onChange={(e) => setUser(e.target.value)}
            /> */}
            <ThemeProvider theme={theme}>
              <Button
                onClick={createVideoHandler}
                sx={{ marginTop: 3, boxShadow: 'none !important' }}
                variant='contained'
                color='neutral'
              >
                Create
              </Button>
            </ThemeProvider>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Modalvideolist;
